<template>
    <div class="container" v-if="!fetching">
        <div class="section">
            <img class="img" src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/test_engineer/h5/%E8%87%AA%E5%8A%A8%E5%8C%96%E6%B5%8B%E8%AF%95%E5%90%8D%E4%BC%81-H5%402x.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220902/1662103899026.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220902/1662103908052.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220902/1662103917965.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220902/1662103929273.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220902/1662106481251.png">
        </div>
        <div class="section-main">
            <div class="s-main">
                <van-tabs v-model="active">
                    <van-tab v-for="(item, index) in stageList" :key="index" :title="item.stage" class="tb">
                        <div class="t-title">
                            {{item.title}}
                        </div>
                        <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png">
                        <div class="target">
                            <div class="title">
                                <div class="target-link"></div>
                                <div class="text">学习目标</div>
                                <div v-if="item.details.length > 0" class="btn" @click="showModal(item)"></div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.phaseTargetList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                            <div class="title title1">
                                <div class="target-link"></div>
                                <div class="text">关键技术点</div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.skillsList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
                <button class="stage-more" @click="JumpFn('领取完整课程安排')">
                    <img src="https://s21.lgstatic.com/growth/activity/20210824/1629773395225.png">
                </button>
                <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220902/1662106524018.png">
        </div>
        <div class="section-main section-main2">
            <div class="s-main">
                <van-tabs v-model="active2">
                    <van-tab v-for="(item, index) in projectsDetail" :key="index" :title="item.title" class="tb">
                        <div class="t-title">
                            {{ item.projectTitle }}
                        </div>
                        <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png">
                        <div class="target">
                            <div v-for="(detail, k) in item.details" :key="k">
                                <div class="title">
                                    <div class="target-link"></div>
                                    <div class="text">{{ detail.title }}</div>
                                </div>
                                <div class="content">
                                    <div class="content-list">
                                        <div class="text">{{ detail.txt }}</div>
                                    </div>
                                </div>
                            </div>
                            <img class="project-img" v-for="(img, j) in item.projectImgs" :src="img" :key="j" alt="">
                        </div>
                    </van-tab>
                </van-tabs>
                <button class="stage-more" @click="JumpFn('获取更多项目资料')">
                    <img src="https://s20.lgstatic.com/growth/activity/20220705/1657012618260.png">
                </button>
                <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220825/1661417870542.png">
        </div>

        <!-- <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220902/1662103940259.jpg">
        </div> -->

        <div :class="{'modal-container': true, active: modalVisable}" v-if="modalVisable">
            <div :class="{'layer': true, active: modalVisable}"/>
            <div class="modal">
                <div class="modal-content active">
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div>
                        <div class="title">
                            {{ moadlData.title }}
                            <div class="sub-title">
                                {{ moadlData.stage }}
                            </div>
                        </div>
                        <div class="content">
                            <div v-for="(val,inde) in moadlData.details" :key="inde">
                                <div class="content-title">
                                    {{val.t}}
                                </div>
                                <div class="content-desi" v-for="(i,its) in val.desc" :key="its">
                                    {{i}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template>
            <ClueFooter
                :bgStyle="{background: 'linear-gradient(90deg, #E30000 0%, #FD8200 100%)'}"
                v-if="firstBtnType"
                :id="135"
                :isDcsj="false"
                showPoup
                @jump="JumpFn('名额有限立即抢占')"
                />
            <button class="footer" @click="JumpFn('名额有限立即抢占')" v-else>
                <img class="img" src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/all_operate/mobile/%E7%BC%96%E7%BB%84%208%402x.png">
                <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
                <FooterPoup
                    :id="135"
                    :isDcsj="false"
                />
            </button>
        </template>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import { Tab, Tabs } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import activity from '../../../common/activity';
import List from './data.js'
export default {
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
    },
    data() {
        return {
            activity,
            List,
            imgList:[],
            imgList1:[],
            imgList2:[],
            swiperList:[],
            stageList:[],
            modalVisable:false,
            moadlData:{},
            swiperListNew:[
                "https://s20.lgstatic.com/growth/activity/20220708/1657249956344.png",
                "https://s21.lgstatic.com/growth/activity/20220708/1657249967504.png",
                "https://s20.lgstatic.com/growth/activity/20220708/1657249976097.png",
                "https://s20.lgstatic.com/growth/activity/20220708/1657249985086.png"
            ],
            projectsDetail: [],
            addressIdsMap: {
                "领取完整课程安排": "u1txj",
                "获取更多项目资料": "v1txk",
                "名额有限立即抢占": "w1txm"
            }
        }
    },
    created () {
        this.saLogin();
    },
    mounted () {
        setTimeout(()=>{
            // this.eduPlatTrack('WebView', { page_id: '1qhg'});
            this.platTrack('h5pv', {
                page_id: '1qhg',
            })
        },500)
        let dataList = this.List.data.h5;
        this.stageList = this.List.data.stageList
        this.projectsDetail = this.List.data.projectsDetail
        this.imgList = dataList.imgList
        this.imgList1 = dataList.imgList1
        this.imgList2 = dataList.imgList2
        this.swiperList = dataList.swiperList
        this.swiperInit()
    },
    methods: {
        swiperInit() {
            let option = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                spaceBetween: 10
            };
            setTimeout(() => {
                const swiper = new Swiper('.current-container2', option);
            }, 500)

        },
        JumpFn(str) {
            // let button_name = '限时领取'
            // if(name && typeof name ==='string'){
            //     button_name = name
            // }
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qhg',
            //     'button_name': button_name
            // });
            str && this.platTrackClickFn(str)
            setTimeout(() => {
                handleJumpUrl(`0279ee5641134bdd9c792ccdf89d319f`);
            }, 200);
        },
        closeModal(){
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;width:100%;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);
        },
        showModal(item){
            console.log(item);
            this.fixedBody();
            this.modalVisable = true;
            this.moadlData = item
        },
        platTrackClickFn(name) {
            this.platTrack('h5click', {
                page_id: '1qhg',
                address_id: this.addressIdsMap[name]
            })
        },
        goAgreement() {
            window.location.href = "https://edu.lagou.com/growth/sem/doc4.html";
        }
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background: #fff;
    padding-bottom: 200px;
    .section {
        position: relative;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
        .btn1 {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 10;
            background-color:transparent;
            border: none;
        }
        .agreement {
            position: absolute;
            bottom: 50px;
            left: 0;
            width: 100%;
            height: 60px;
        }
    }
    .section-main {
        position: relative;
        width: 100%;
        padding-top: 30px;
        background-color: #E6EDFF;
        padding-bottom: 100px;
        &.section-main2 {
            padding-top: 0;
            .content {
                .text {
                    padding: 0 50px;
                    box-sizing: border-box;
                }
            }
            .project-img {
                display: block;
                width: 516px;
                margin: 30px auto 0;
            }
        }
        .s-main {
            position: relative;
            margin: 0 auto;
            width: 688px;
            background-color: #fff;
            z-index: 2;
            border-radius: 8px;
            padding-bottom: 150px;
            box-shadow: 0px 2px 15px 0px rgba(225, 225, 225, 0.73);
            .tb {
                position: relative;
                width: 100%;
                background-color: #fff;
                .t-title {
                    text-align: center;
                    font-size: 32px;
                    color: #555;
                    font-weight: 500;
                    padding: 25px 0 10px;
                }
                .t-icon {
                    width: 688px;
                    display: block;
                    height: 2px;
                }
                .target {
                    color: #3D3D3F;
                    font-size: 26px;
                    margin-top: 35px;
                    .title {
                        display: flex;
                        height: 49px;
                        align-items: center;
                        font-weight: bold;
                    }
                    .title1 {
                        margin-top: 38px;
                    }
                    .target-link {
                        width: 6px;
                        height: 22px;
                        background: linear-gradient(313deg, #7A7AA9 0%, #232545 100%);
                        margin-left: 46px;
                        margin-right: 8px;
                    }
                    .text {
                        flex: 1;
                    }
                    .btn {
                        width: 151px;
                        height: 49px;
                        background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40px;
                    }
                    .content {
                        margin-top: 10px;
                    }
                    .content-list {
                        display: flex;
                        color: #595959;
                        line-height: 48px;
                        font-size: 24px;
                        .icon {
                            width: 8px;
                            height: 8px;
                            background: #565659;
                            border-radius: 50%;
                            margin-left: 46px;
                            margin-top: 20px;
                            margin-right: 8px;
                        }
                        .text {
                            opacity: .7;
                            flex: 1;
                            width: 612px;
                            padding-right: 14px;
                        }
                    }
                }
            }
            .tips-tab {
                position: absolute;
                bottom: 80px;
                right: 40px;
                color: #666;
                font-size: 12px;
            }
            .stage-more {
                position: absolute;
                bottom: -54px;
                left: 50%;
                transform: translate(-50%);
                width: 488px;
                background-color:transparent;
                border: none;
                z-index: 9;
                img {
                    width: 100%;
                    display: block;
                }
            }
        }
        /deep/ .van-tabs__wrap{
            height: 106px;
        }
        /deep/ .van-tabs__nav {
            background: linear-gradient(322deg, #477EFF 0%, #3560E1 100%);
            height: 106px;
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        /deep/ .van-tab {
            width: 200px;
            height: 106px;
            color: #fff;
            font-size: 28px;
            font-weight: 400;
        }
        /deep/ .van-tabs__line {
            bottom: 40px;
            background: #fff;
            width: 64px;
            height: 6px;
        }
    }
    /deep/ .current-wrap {
        width: 100%;
        height: 14.8rem;
        .swiper-wrapper {
            width:100%;
            img {
                width: 100%;
            }
        }
        .swiper-pagination-bullet {
            border-radius: 50%;
            width: 0.16rem;
            height: 0.173rem;
            background: linear-gradient(181deg, #3560E1 0%, #477EFF 100%);
            opacity: 0.5;
            margin: 0 0.093rem;
            &-active {
                width: 0.48rem;
                height: 0.173rem;
                background: linear-gradient(181deg, #3560E1 0%, #477EFF 100%);
                border-radius: 4px;
                opacity: 1;
            }
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        box-shadow: 0px -12px 12px 0px rgba(156, 157, 185, 0.22);
        .img {
            width: 100%;
            display: block;
        }
        .H5activityIcon {
            position: absolute;
            top: -50px;
            right: 42px;
            width: 209px;
        }
    }


    .layer {
        position: fixed;
        z-index: 9;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        &.active {
            display: block;
        }
    }
    .modal {
        position: fixed;
        bottom: 180px;
        z-index: 10;
        display: flex;
        justify-content: center;
        .modal-content {
            width: 750px;
            height: 0;
            opacity: 0;
            transition: height .3s linear;
            overflow-y: scroll;
            // padding-bottom: 100px;
            &.active {
                opacity: 1;
                height: 962px;
                overflow: hidden;
            }
            background: #fff;
            border-radius: 18px 18px 0 0;
            position: relative;
            margin-right: 45px;
            box-sizing: border-box;
        }
        .close {
            width: 42px;
            height: 42px;
            background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png") no-repeat;
            background-size: 42px 42px;
            position: absolute;
            right: 30px;
            top: 30px;
            border-radius: 50%;
            z-index: 1;
        }
        .title {
            margin-top: 82px;
            width: 658px;
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 41px;
            padding-left: 45px;
            font-weight: bold;
            &-dot {
                width: 5px;
                height: 5px;
                border-radius: 5px;
                background: #FA4000;
            }
            .sub-title{
                color: #C69C6D;
                font-size: 26px;
                margin-top: 8px;
            }
        }
        .content {
            height: 755px;
            overflow-y: scroll;
            padding-bottom: 100px;
            background-color: #fff;
            .item {
                padding-bottom: 60px;
            }
        }
        .content-title {
            margin-bottom: 20px;
            font-weight: bold;
            color: #191F34;
            position: relative;
            padding-left: 27px;
            font-size: 26px;
            line-height: 28px;
            padding-right: 30px;

        }
        .content-desi {
            position: relative;
            margin-bottom: 30px;
            color: #5E6476;
            font-size: 26px;
            padding-left: 48px;
            padding-right: 30px;
            &:before {
                content: '';
                width: 8px;
                height: 8px;
                background: #C69C6D;
                border-radius: 8px;
                position: absolute;
                left: 30px;
                top: 14px;
            }
        }
    }
}
.sw2 {
    position: relative;
    width: 100%;
    height: 674px;
    padding: 0 28px;
    box-sizing: border-box;
    img {
        width: 357px;
    }
    .current-container2 {
        width: calc(100% - 30px);
        height: 674px;
        position: absolute;
        bottom: 0;
        left: 30px;
        .current-wraps {
            width: 357px;
            position: absolute;
            padding-left: 10px;
            .current-box {
                width:357px !important;
                // margin-left: 20px;
                img {
                    width: 100%;
                }
            }
        }
    }
}
</style>
